export enum AppointmentScheduleBusyReason {
  TimeIsBusyAnotherAppointment = 0,
  BlockedScheduleTime,
  OutsideUserScheduleTime,
  WorkAreaIsBusyAnotherAppointment,
  OutsideBusinessHours,
  OutsideUserScheduleTimeAndOutsideBusinessHours,
  TimeIsBusyAnotherAppointmentCanNotContinue
}
